module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/65.4195c575.png";